var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.hasLayout,{tag:"component",attrs:{"id":"main"}},[_c('router-view',{key:_vm.$route.params.page || ''})],1)}
var staticRenderFns = []

export { render, staticRenderFns }